module.exports = __webpack_public_path__ + "img/stops.64c15564.svg";